package at.apa.statistictracker.coroutines

import kotlinx.coroutines.*
import kotlin.coroutines.CoroutineContext

internal class StatisticTrackerCoroutineScope : CoroutineScope {
    private val job = SupervisorJob()
    private val dispatcher = Dispatchers.Default
    private val context = job + dispatcher

    override val coroutineContext: CoroutineContext = context
}